module.exports = __webpack_public_path__ + "static/media/event-countdown-timer.38a5360a.png";